import {
  UPDATE_INS_MEDIA_LIST_INFO,
  UPDATE_ONE_INS_POST_INFO,
  UPDATE_INS_USER_MEDIA_STATUS,
  CREATE_DEFAULT_INS_USER_MEDIA,
  UPDATE_CURRENT_POST_ID,
  CLEAR_INS_USER_MEDIA_LIST
} from "@/store/constants/ins_media_types";
import {
  OneUserMediaInfoList,
  InsUserMediaList
} from "@/store/modules/ins_media_module";
export default {
  [UPDATE_INS_MEDIA_LIST_INFO](state: InsUserMediaList, payload: any) {
    const { media_data, update_mode, user_id } = payload;
    const findIndex = state.ins_user_media_list.findIndex(
      (item: OneUserMediaInfoList) => item.user_id === user_id
    );

    if (findIndex > -1) {
      if (update_mode === "update") {
        // 更新存在的用户
        const findMediaInfo = state.ins_user_media_list[findIndex];
        const updateMediaInfo = {
          ...findMediaInfo,
          ...media_data
        };
        state.ins_user_media_list.splice(findIndex, 1, updateMediaInfo);
      } else if (update_mode === "load_more") {
        // 加载更多post;
        const findMediaInfo = state.ins_user_media_list[findIndex];
        const { ins_media_list, more_available, next_max_id } = media_data;
        findMediaInfo.more_available = more_available;
        findMediaInfo.next_max_id = next_max_id;
        findMediaInfo.ins_media_list = [
          ...findMediaInfo.ins_media_list,
          ...ins_media_list
        ];
        state.ins_user_media_list.splice(findIndex, 1, findMediaInfo);
      } else if (update_mode === "delete") {
        state.ins_user_media_list.splice(findIndex, 1);
      }
    } else {
      return Promise.reject("Cannot find exist user.");
    }
  },
  [UPDATE_CURRENT_POST_ID](state: any, payload: string) {
    state.current_post_id = payload;
  },
  [UPDATE_ONE_INS_POST_INFO](state: any, payload: any) {
    try {
      const { user_id, media_id, item } = payload;
      const findUserIndex = state.ins_user_media_list.findIndex((user: any) => {
        return user_id === user.user_id;
      });
      if (findUserIndex > -1) {
        const userMediaList =
          state.ins_user_media_list[findUserIndex].ins_media_list;
        const findMediaIndex = userMediaList.findIndex((media: any) => {
          return media_id === media.id;
        });
        if (findMediaIndex > -1) {
          userMediaList.splice(findMediaIndex, 1, item);
        } else {
          return Promise.reject("Cannot find same post.");
        }
      } else {
        return Promise.reject("Cannot find exist user.");
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  [CREATE_DEFAULT_INS_USER_MEDIA](state: any, payload: any) {
    try {
      const { user_id, ins_user_media } = payload;
      const findUserIndex = state.ins_user_media_list.findIndex((user: any) => {
        return user_id === user.user_id;
      });
      if (findUserIndex > -1) {
        // 相同用户直接替换
        state.ins_user_media_list.splice(findUserIndex, 1, ins_user_media);
      } else {
        // 没有相同用户
        state.ins_user_media_list.unshift(ins_user_media);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  [UPDATE_INS_USER_MEDIA_STATUS](state: any, payload: any) {
    try {
      // 用来更新拉取的状态
      const { user_id, fetch_status, fetched } = payload;
      const findUserIndex = state.ins_user_media_list.findIndex((user: any) => {
        return user_id === user.user_id;
      });
      if (findUserIndex > -1) {
        // 找到的用户list
        const findUserMedia = state.ins_user_media_list[findUserIndex];
        if (fetch_status !== undefined) {
          findUserMedia.fetch_status = fetch_status;
        }

        if (fetched !== undefined) {
          findUserMedia.fetched = fetched;
        }
        state.ins_user_media_list.splice(findUserIndex, 1, findUserMedia);
      } else {
        return Promise.reject("Cannot find exist user.");
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  // [UPDATE_INS_USER_MEDIA_STATUS](state: any, payload: any) {
  //   //
  // },
  [CLEAR_INS_USER_MEDIA_LIST](state: any, payload: string) {
    state.ins_user_media_list = [];
    state.current_post_id = null;
  }
};
